import React, { useMemo, useState } from "react";
import { Button, Drawer, Popconfirm, Space, Tooltip } from "antd";
import { DeleteOutlined, DownloadOutlined, EyeOutlined } from "@ant-design/icons";
import ResizableProTable from "@components/Table/ResizableProTable";
import moment from "moment";
import Auth from "@/components/Auth";
import { deleteFacilityReport, getFacilityReportList } from "@/redux/api";
import { usePdfContext } from "@containers/PdfReport/context";

const request = async () => {
  const response = await getFacilityReportList();
  return {
    data: response?.data?.results || [],
    total: response?.data?.count || 0,
    success: true,
  };
};

const handleDownload = (record) => {
  const link = document.createElement("a");
  link.href = record.attachment;
  link.download = `${record.name}.pdf`;
  link.target = "_blank";
  link.click();
};

const ReportTable = () => {
  const { openDrawer, tableActionRef, goToFormStep, initForm, reloadTable } = usePdfContext();
  const [previewUrl, setPreviewUrl] = useState("");
  const [previewVisible, setPreviewVisible] = useState(false);

  const columns = useMemo(
    () => [
      { title: "Name", dataIndex: "name", key: "name", search: false },
      { title: "Create By", dataIndex: "createdby_name", key: "createdby_name", search: false },
      {
        title: "Create Date",
        dataIndex: "created_date",
        key: "created_date",
        search: false,
        render: (value) => moment(value).format("YYYY-MM-DD HH:mm:ss"),
      },
      {
        title: "Operations",
        key: "action",
        search: false,
        render: (_, record) => (
          <Space size="middle">
            <Tooltip title="Download">
              <Button type="link" onClick={() => handleDownload(record)}>
                <DownloadOutlined />
              </Button>
            </Tooltip>
            <Tooltip title="View pdf">
              <Button
                type="link"
                onClick={() => {
                  setPreviewUrl(record.attachment);
                  setPreviewVisible(true);
                }}
              >
                <EyeOutlined />
              </Button>
            </Tooltip>
            <Auth code="customreport" level={3}>
              <Popconfirm
                title="Are you sure to delete this report?"
                onConfirm={async () => {
                  await deleteFacilityReport(record.id);
                  reloadTable();
                }}
              >
                <Button type="link">
                  <DeleteOutlined />
                </Button>
              </Popconfirm>
            </Auth>
          </Space>
        ),
      },
    ],
    [reloadTable]
  );

  return (
    <div style={{ padding: 5 }}>
      <Drawer width="100%" open={previewVisible} onClose={() => setPreviewVisible(false)}>
        {previewVisible && previewUrl ? (
          <iframe title="facility-report-preview" style={{ width: "100%", height: "86vh" }} src={previewUrl} />
        ) : null}
      </Drawer>
      <ResizableProTable
        actionRef={tableActionRef}
        search={false}
        columns={columns}
        request={request}
        toolBarRender={() => (
          <Space className="my-4" size={30}>
            <Button className="reload-refresh-btn" onClick={reloadTable}>
              <i className="fas fa-sync pr-3"></i>Refresh
            </Button>
            <Auth code="customreport" level={2}>
              <Button
                type="primary"
                onClick={() => {
                  goToFormStep();
                  initForm();
                  openDrawer();
                }}
              >
                <i className="fas fa-plus pr-3"></i>Report Builder
              </Button>
            </Auth>
          </Space>
        )}
        options={{
          setting: true,
          density: false,
          fullScreen: false,
          reload: false,
        }}
      />
    </div>
  );
};

export default ReportTable;
